// misc actions
export const SHOW_MAIN_NAVBAR = 'SHOW_MAIN_NAVBAR'

export const SHOW_SIDE_BAR = 'SHOW_SIDE_NAVBAR'
export const HIDE_SIDE_BAR = 'HIDE_SIDE_NAVBAR'

export const SHOW_CHILD_SIDE_BAR = 'SHOW_CHILD_SIDE_NAVBAR'
export const HIDE_CHILD_SIDE_BAR = 'HIDE_CHILD_SIDE_NAVBAR'

export const SHOW_MESSAGE_MODAL = 'SHOW_MESSAGE_MODAL'
export const HIDE_MESSAGE_MODAL = 'HIDE_MESSAGE_MODAL'

export const SHOW_UTIL_MODAL = 'SHOW_UTIL_MODAL'
export const HIDE_UTIL_MODAL = 'HIDE_UTIL_MODAL'

export const SHOW_CONTACT_INFO = 'SHOW_CONTACT_INFO'
export const HIDE_CONTACT_INFO = 'HIDE_CONTACT_INFO'

export const SHOW_PRODUCT_MODAL = 'SHOW_PRODUCT_MODAL'
export const HIDE_PRODUCT_MODAL = 'HIDE_PRODUCT_MODAL'

export const SHOW_PAKKET_MODAL = 'SHOW_PAKKET_MODAL'
export const HIDE_PAKKET_MODAL = 'HIDE_PAKKET_MODAL'

export const SHOW_ORDER_MODAL = 'SHOW_ORDER_MODAL'
export const HIDE_ORDER_MODAL = 'HIDE_ORDER_MODAL'

// product actions
export const ADD_NEW_PRODUCT = 'ADD_NEW_PRODUCT'
export const GET_PRODUCTS = 'GET_PRODUCTS'
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS'
export const ADD_PAKKET_PRODUCTS = 'ADD_PAKKET_PRODUCTS'
export const GET_PAKKETTEN = 'GET_PAKKETTEN'
export const GET_ALL_PAKKETTEN = 'GET_ALL_PAKKETTEN'

// shop actions
export const SET_FILTERS = 'SET_FILTERS'
export const SET_PAKKET_FILTERS = 'SET_PAKKET_FILTERS'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'

export const SET_SUB_FILTERS = 'SET_SUB_FILTERS'
export const CLEAR_SUB_FILTERS = 'CLEAR_SUB_FILTERS'

export const HANDLE_SEARCH = 'HANDLE_SEARCH'

// user actions
export const REGISTER_NEW_USER = 'REGISTER_NEW_USER'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const SIGN_USER_OUT = 'SIGN_USER_OUT'

// profile actions
export const DELETE_PROFILE = 'DELETE_PROFILE'
export const GET_PROFILE = 'GET_PROFILE'

// cart actions
export const GET_CART = 'GET_CART'
export const GET_ALL_CLIENT_CART_DATA = 'GET_ALL_CLIENT_CART_DATA'

// order actions
export const GET_ORDERS = 'GET_ORDERS'
export const GET_CLIENT_ORDERS = 'GET_CLIENT_ORDERS'
export const CANCEL_ORDER = 'CANCEL_ORDER'

//  admin actions
export const ADMIN_LOGIN = 'ADMIN_LOGIN'
export const ADMIN_LOGOUT = 'ADMIN_LOGOUT'

// error actions
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const HAS_ERRORS = 'HAS_ERRORS'





